export default function TermsOfUse() {
  const G = "#0077B5";
  const style = {
    body: { background: "#fff", minHeight: "100vh", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" },
    wrap: { maxWidth: 800, margin: "0 auto", padding: "48px 24px 80px" },
    logo: { fontFamily: "'Playfair Display',Georgia,serif", fontSize: 28, fontWeight: 700, color: G, marginBottom: 40, display: "block", textDecoration: "none" },
    h1: { fontFamily: "'Playfair Display',Georgia,serif", fontSize: 32, fontWeight: 700, color: "#1A1A1A", marginBottom: 8, marginTop: 0 },
    updated: { fontSize: 13, color: "#888", marginBottom: 48 },
    h2: { fontFamily: "'Playfair Display',Georgia,serif", fontSize: 20, fontWeight: 700, color: "#1A1A1A", marginTop: 44, marginBottom: 12, borderBottom: "2px solid #F3F2EF", paddingBottom: 8 },
    p: { fontSize: 15, lineHeight: 1.8, color: "#333", marginBottom: 16 },
    ul: { fontSize: 15, lineHeight: 1.8, color: "#333", marginBottom: 16, paddingLeft: 24 },
    footer: { borderTop: "1px solid #E1E9EE", marginTop: 64, paddingTop: 20, textAlign: "center", fontSize: 13, color: "#aaa" },
    link: { color: G },
  };
  return (
    <div style={style.body}>
      <div style={style.wrap}>
        <a href="https://brandhives.com" style={style.logo}>BrandHives</a>
        <h1 style={style.h1}>Terms of Use</h1>
        <div style={style.updated}>Last updated: March 31, 2026</div>

        <p style={style.p}>
          These Terms of Use ("Terms") govern your use of BrandHives, a LinkedIn content automation service operated by BHIVE Social Media Labs ("BHIVE", "we", "us"). By creating an account you agree to these Terms.
        </p>

        <h2 style={style.h2}>1. The Service</h2>
        <p style={style.p}>
          BrandHives automatically generates and publishes LinkedIn posts on your behalf using artificial intelligence. You authorize BrandHives to connect to your LinkedIn account and post content according to your selected schedule and preferences.
        </p>

        <h2 style={style.h2}>2. Your Account</h2>
        <ul style={style.ul}>
          <li>You must be 16 or older to use BrandHives.</li>
          <li>You are responsible for maintaining the security of your account credentials.</li>
          <li>You must provide accurate information during registration.</li>
          <li>One account per person. You may not share accounts or create accounts on behalf of others without their explicit consent.</li>
        </ul>

        <h2 style={style.h2}>3. AI-Generated Content</h2>
        <ul style={style.ul}>
          <li>All content generated by BrandHives is produced by artificial intelligence.</li>
          <li>You are solely responsible for reviewing, approving, and publishing all content to your LinkedIn profile.</li>
          <li>BHIVE does not guarantee the accuracy, completeness, or appropriateness of any generated content.</li>
          <li>Licensed professionals (lawyers, accountants, financial advisors) are solely responsible for ensuring all published content complies with their applicable professional and regulatory obligations. BrandHives' Compliance Assist feature is informational only and does not constitute legal or regulatory advice.</li>
        </ul>

        <h2 style={style.h2}>4. LinkedIn Authorization</h2>
        <p style={style.p}>By connecting your LinkedIn account you authorize BHIVE to:</p>
        <ul style={style.ul}>
          <li>Read your basic profile information</li>
          <li>Publish posts to your LinkedIn profile on your behalf</li>
          <li>Access your LinkedIn follower count</li>
        </ul>
        <p style={style.p}>
          You can revoke this authorization at any time through your LinkedIn account settings or by disconnecting through BrandHives Settings. Revoking authorization will pause all scheduled posts.
        </p>

        <h2 style={style.h2}>5. Subscription and Billing</h2>
        <ul style={style.ul}>
          <li>BrandHives is offered on a subscription basis. Pricing is displayed at signup and may change with 30 days notice.</li>
          <li>Your subscription renews automatically unless cancelled.</li>
          <li>Refunds are not provided for partial billing periods.</li>
          <li>We reserve the right to suspend accounts with failed payments.</li>
        </ul>

        <h2 style={style.h2}>6. Acceptable Use</h2>
        <p style={style.p}>You may not use BrandHives to:</p>
        <ul style={style.ul}>
          <li>Post content that violates LinkedIn's Terms of Service</li>
          <li>Publish spam, misleading, defamatory, or illegal content</li>
          <li>Impersonate any person or organization</li>
          <li>Violate any applicable law or regulation</li>
          <li>Attempt to reverse engineer or circumvent any part of the service</li>
        </ul>
        <p style={style.p}>
          BHIVE reserves the right to suspend or terminate accounts that violate these rules without refund.
        </p>

        <h2 style={style.h2}>7. Intellectual Property</h2>
        <ul style={style.ul}>
          <li>You retain ownership of your LinkedIn profile and any content you create or approve through BrandHives.</li>
          <li>You grant BHIVE a limited license to generate, store, and publish content on your behalf as directed by your account settings.</li>
          <li>BHIVE retains all rights to the BrandHives platform, software, and underlying technology.</li>
        </ul>

        <h2 style={style.h2}>8. Disclaimer of Warranties</h2>
        <p style={style.p}>
          BrandHives is provided "as is" without warranty of any kind. BHIVE does not warrant that the service will be uninterrupted, error-free, or that generated content will meet your specific requirements or comply with any professional standards.
        </p>

        <h2 style={style.h2}>9. Limitation of Liability</h2>
        <p style={style.p}>
          To the maximum extent permitted by applicable law, BHIVE's total liability for any claims arising from your use of BrandHives shall not exceed the amount you paid to BHIVE in the 1 month preceding the claim.
        </p>
        <p style={style.p}>
          BHIVE is not liable for any indirect, incidental, or consequential damages including lost profits, lost data, or reputational harm.
        </p>

        <h2 style={style.h2}>10. Termination</h2>
        <ul style={style.ul}>
          <li>You may cancel your account at any time through Settings → Account.</li>
          <li>Cancellation stops all future posts and billing at the end of the current billing period.</li>
          <li>BHIVE may terminate your account for violation of these Terms with or without notice.</li>
        </ul>

        <h2 style={style.h2}>11. Governing Law</h2>
        <p style={style.p}>
          These Terms are governed by the laws of the Province of Ontario and the federal laws of Canada applicable therein. Any disputes shall be resolved in the courts of Toronto, Ontario.
        </p>

        <h2 style={style.h2}>12. Changes to These Terms</h2>
        <ul style={style.ul}>
          <li>We may update these Terms at any time.</li>
          <li>We will notify you by email at least 14 days before material changes take effect.</li>
          <li>Continued use of BrandHives after changes take effect constitutes acceptance of the new Terms.</li>
        </ul>

        <h2 style={style.h2}>13. Contact</h2>
        <p style={style.p}>
          BHIVE Social Media Labs<br />
          65 Jefferson Avenue, Toronto, ON<br />
          <a href="mailto:operator@bhive.ca" style={style.link}>operator@bhive.ca</a>
        </p>

        <div style={style.footer}>
          AI by Claude · Payments secured by Stripe · Developed by BHIVE™ Labs
        </div>
      </div>
    </div>
  );
}
